"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _defer = _interopRequireDefault(require("lodash/fp/defer"));
var _dom = require("../dom");
function useAbsoluteFocusHandler(callback, deps) {
  var currentTarget = (0, _react.useRef)(null);
  return (0, _react.useCallback)(function (e) {
    currentTarget.current = e.currentTarget;
    (0, _defer["default"])(function () {
      var _currentTarget$curren;
      if ((0, _dom.isInDOM)(currentTarget.current) && (_currentTarget$curren = currentTarget.current) !== null && _currentTarget$curren !== void 0 && _currentTarget$curren.contains((0, _dom.getActiveElement)())) {
        callback(e);
      }
    });
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
var _default = exports["default"] = useAbsoluteFocusHandler;